import { getApiCall, getChecklistMaster } from 'api/apiService';
import { GET_BUYERID, LOGGED_FROM, USER_MAIL_ID } from 'constant/app.config';

export const handleactivitylink = async (
  datavalue,
  title,
  history,
  primaryUserTypeValue,
  binderid,
  setSelectedBuyerid,
  userId,
  setOpenbuyercard,
  setShowMessage,
  setMessagedata
) => {
  if (
    title === 'New Property Listing Added' ||
    title === 'Property Published'
  ) {
    history.push({
      pathname: `/dashboard`,
    });
  } else if (
    title === 'Due Diligence Commenced' ||
    title === 'Due Diligence Completed'
  ) {
    if (primaryUserTypeValue === 'Agent') {
      setSelectedBuyerid(userId);
      setOpenbuyercard(true);
      history.push({
        pathname: `/dashboard/view-dashboard/${datavalue}`,
      });
    }
  } else if (
    title === 'Deposit Payment Requested' ||
    title === 'Deposit Payment Request' ||
    title === 'Deposit Payment Processed' ||
    title === 'Deposit Payment Received'
  ) {
    if (primaryUserTypeValue === 'Agent') {
      setSelectedBuyerid(userId);
      history.push({
        pathname: `/dashboard/view-dashboard/${datavalue}`,
      });
    }
  } else if (
    title === 'Inspection Completed' ||
    title === 'Inspection Requested' ||
    title === 'Inspection Scheduled'
  ) {
    if (primaryUserTypeValue === 'Vendor') {
      history.push({
        pathname: `/dashboard/viewactive-dashboard/${datavalue}`,
      });
      setTimeout(() => {
        window.scrollTo({
          top: 1000,
          behavior: 'smooth',
        });
      }, 500);
    }
    if (primaryUserTypeValue === 'Buyer') {
      history.push({
        pathname: `/market/${datavalue}`,
      });
    }
    if (primaryUserTypeValue === 'Agent') {
      history.push({
        pathname: `/dashboard/view-dashboard/${datavalue}`,
      });
    }
  } else if (
    title == 'Campaign Live' ||
    title === 'Stage 2 Commenced' ||
    title === 'Campaign Paused' ||
    title === 'Campaign Resumed' ||
    title === 'Campaign Ended' ||
    title === 'Property Sold'
  ) {
    if (primaryUserTypeValue === 'Vendor') {
      history.push({
        pathname: `/dashboard/viewactive-dashboard/${datavalue}`,
      });
    }
    if (primaryUserTypeValue === 'Agent') {
      history.push({
        pathname: `/dashboard/view-dashboard/${datavalue}`,
      });
    }
    if (primaryUserTypeValue === 'Buyer') {
      history.push({
        pathname: `/market/${datavalue}`,
      });
    }
  } else if (
    title == 'New Offer Received' ||
    title === 'Offer Accepted' ||
    title === 'Offer Rejected' ||
    title === 'Offer Withdrawn' ||
    title === 'Counter Offer Received' ||
    title === 'Current Offer Updated' ||
    title == 'New Contract Received' ||
    title === 'Stage 2 - Closed' ||
    title === 'Stage 2 - Final Offers' ||
    title === 'Property SOLD' ||
    title === 'Offer Withdrawn' ||
    title == 'Offer Received'
  ) {
    if (primaryUserTypeValue === 'Vendor') {
      history.push({
        pathname: `/dashboard/viewactive-dashboard/${datavalue}`,
      });
    }
    if (primaryUserTypeValue === 'Agent') {
      history.push({
        pathname: `/dashboard/view-dashboard/${datavalue}`,
      });
    }
    if (primaryUserTypeValue === 'Buyer') {
      history.push({
        pathname: `/market/${datavalue}`,
      });
    }
  } else if (title == 'CONGRATULATIONS') {
    if (primaryUserTypeValue === 'Vendor') {
      history.push({
        pathname: `/dashboard/viewactive-dashboard/${datavalue}`,
      });
    }
    if (primaryUserTypeValue === 'Buyer') {
      getChecklistMaster(datavalue).then((res) => {
        if (res?.status == '1') {
          // Find the task with the name "Sign Contract"
          const signContractTask = res?.TaskList.find(
            (task) => task.taskName === 'Sign Contract'
          );
          // Extract the isDone value
          const isDone = signContractTask ? signContractTask.isDone : null;
          const binder = signContractTask ? signContractTask.binderId : null;
          if (isDone == 1) {
            history.push({
              pathname: `/market/${datavalue}`,
            });
          } else {
            if (LOGGED_FROM == 'Mobile') {
              window.open(
                `com.comm-app://LoginPage?mailid=${USER_MAIL_ID}&binder=${binder}`,
                '_blank'
              );
            } else {
              setShowMessage(true);
              setMessagedata({ binderId: binder });
            }
          }
        }
      });
    }
  } else if (
    title === '66W Certificate Requested' ||
    title === '66W Certificate Signed' ||
    title === 'Contract Review' ||
    title === 'Contract Amendments' ||
    title === 'Contract Signed'
  ) {
    if (primaryUserTypeValue === 'Vendor') {
      history.push({
        pathname: `/dashboard/viewactive-dashboard/${datavalue}`,
      });
    } else {
      if (LOGGED_FROM == 'Mobile') {
        window.open(
          `com.comm-app://LoginPage?mailid=${USER_MAIL_ID}&binder=${binderid}`,
          '_blank'
        );
      } else {
        setShowMessage(true);
        setMessagedata({ binderId: binderid });
      }
    }
  } else return null;
};
